module.exports = __webpack_public_path__ + "static/media/gb.64c805cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gb.gif
// module id = 196
// module chunks = 0